import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  serviceCreateAdmin,
  serviceUpdateAdmin,
  serviceGetAdminDetails,
} from "../../../services/AdminUsers.service";
import { serviceGetList } from "../../../services/index.services";
import SnackbarUtils from "../../../libs/SnackbarUtils";
import historyUtils from "../../../libs/history.utils";
import { useParams } from "react-router";
import { isEmail, validateRegexPassword } from "../../../libs/RegexUtils";

const initialForm = {
    name: "",
    email: "",
    type: "",
    role_id: "",
    client_ids: [],
    program_ids: [],
    password: "",
    is_approver: true,
    confirm_password: "",

};
const useAdminUsersCreateHook = () => {
    const [form, setForm] = useState({ ...initialForm });
    const [errorData, setErrorData] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [AdminDetails, setAdminDetails] = useState(null);
    const [listData, setListData] = useState({
      CLIENTS: [],
      PROGRAMS: [],
      ROLES: [],
    });
    const { id } = useParams();

    useEffect(() => {
      (async () => {
        const promises = await Promise.allSettled([serviceGetList(["CLIENTS", "PROGRAMS", "ROLES"])]);
        const ProductList = promises[0]?.value?.data;
        setListData(ProductList);
      })();
    }, []);

    useEffect(() => {
      if (id) {
        serviceGetAdminDetails({ id }).then((res) => {
          if (!res?.error) {
            const data = res?.data;
            console.log("Fetched details:", data);
           
            const obj = {};
            Object.keys({ ...initialForm })?.forEach((key) => {
              if (key === "client_ids") {
                obj[key] = data.client_ids.map((clientId) => {
                  const client = data.clients.find((c) => c._id === clientId);
                  return client ? client.name : ""; 
                });
              } 
              else if (key === "program_ids") {
                obj[key] = data.program_ids.map((programId) => {
                  const program = data.programs.find((p) => p._id === programId);
                  return program ? program.name : ""; 
                });
              } 
              // if (key === "client_ids") {
              //   obj[key] = data?.clients?.map((clientId) => ({
              //     label: clientId?.name, 
              //     id: clientId,
              //   }));
               
              // } 
              // else if (key === "program_ids") {
              //   obj[key] = data?.program_ids?.map((programId) => ({
              //     label: "Program name placeholder", 
              //     id: programId,
              //   }));
              // } 
              // if (key === "client_ids") {
              //   obj[key] = {
              //     label: data?.client?.name,
              //     name: data.client.name,
              //     id: data?.client?.id,
              //   };
              // } 
              // else if (key === "program_ids") {
              //   obj[key] = data?.programs?.map((dT) => ({
              //     ...dT,
              //     label: dT?.name,
              //   }));
              // }
              else if (key === "role_id") {
                
                obj[key] =  data?.role?.id
                ?  {
                  label: data?.role?.name,
                   name: data.role?.name,
                  id: data?.role?.id,
                } : "";
              }  
               else 
              if (key === "status") {
                obj[key] = data[key] === "ACTIVE";
              } else {
                obj[key] = data[key] || "";
              }
            });
  
            obj.id = data.id;
           
            setForm({
              ...obj,
              
             
            });
            
            setAdminDetails(data);
          }
        });
      }
    }, [id]);



    const checkFormValidation = useCallback(() => {
      const errors = {...errorData};
      let required = [ "name", "email", "type",  "role_id"];
      if(form?.type === "CLIENT_USER"){
        required.push("program_ids", "client_ids");
      } 
      if(!id){
          required.push("password", "confirm_password");
      }  
      required.forEach((val) => {
        if (
          (!form?.[val] && parseInt(form?.[val]) !== 0) ||
          (Array.isArray(form?.[val]) && form?.[val]?.length === 0)
        ) {
          errors[val] = true;
        }
      });
      if (!isEmail(form?.email)) {
        errors["email"] = true;
      }
      if(form?.password && !id &&  !validateRegexPassword(form?.password)){
          errors["password"] = true;
        }
      if (form?.password && form?.confirm_password && form.password !== form.confirm_password) {
        errors.confirm_password = "Passwords do not match";
      } 

      
      
      Object.keys(errors).forEach((key) => {
        if (!errors[key]) {
          delete errors[key];
        }
      });
      return errors;
    }, [form, errorData]);

    const removeError = useCallback(
        (title) => {
          const temp = JSON.parse(JSON.stringify(errorData));
          temp[title] = false;
          setErrorData(temp);
        },
        [setErrorData, errorData, form]
      );
       console.log("admin form => ", form);
    
      const changeTextData = useCallback(
        (text, fieldName) => {
          let shouldRemoveError = true;
          const t = { ...form };
    
          if (fieldName === "name") {
            if (text.length <= 80) {
              t[fieldName] = text;
            }
          } else if (fieldName === "type") {
            t[fieldName] = text;
            t["client_ids"] = [];
            t["program_ids"] = [];
            
          } else if (fieldName === "program_ids") {
            const uniqueData = Object.values(
              text?.reduce((acc, item) => {
                acc[item?.id] = item;
                return acc;
              }, {})
            );
            t[fieldName] = uniqueData;
          }  else {
            t[fieldName] = text;
          }
    
          setForm(t);
    
         
    
          shouldRemoveError && removeError(fieldName);
        },
        [removeError, form, setForm,]
      );

      const submitToServer = useCallback(() => {
        if (!isSubmitting) {
          setIsSubmitting(true);
    
          const formData = {};
          Object.keys({ ...initialForm }).forEach((key) => {
            if (key === "client_ids") {
              formData["client_ids"] = Array.isArray(form?.client_ids)
              ? form.client_ids.map((client) => client.id)
              : form?.client_ids?.id ? [form.client_ids.id] : [];
            } else if (key === "program_ids") {
              formData["program_ids"] = Array.isArray(form?.program_ids)
              ? form.program_ids.map((program) => program.id)
              : form?.program_ids?.id ? [form.program_ids.id] : [];
            } else if (key === "role_id") {             
              formData["role_id"] = form?.role_id?.id;
            } else if (key === "is_approver") {
              formData["is_approver"] = form[key] ? true : false;
            } else if(key === "confirm_password"){
              return;
            }else {
              formData[key] = form[key];
            }
          });
          // if (form.id) {
          //   formData.id = form.id;
          // }
         
    
          const serviceCall =
            form.id 
              ? serviceUpdateAdmin
              : serviceCreateAdmin;
          serviceCall({...formData, id: form.id}).then((res) => {
            if (!res.error) {
              const message = form.id 
                ? "Updated successfully"
                : "Created successfully";
              SnackbarUtils.success(message);
              historyUtils.goBack();
            } else {
              SnackbarUtils.error(res?.message);
            }
            setIsSubmitting(false);
          });
        }
      }, [form, isSubmitting, setIsSubmitting]);

      const handleSubmit = useCallback(
        async (status) => {
          const errors = checkFormValidation();
          if (Object.keys(errors)?.length > 0) {
            setErrorData(errors);
            return true;
          }
          submitToServer(status);
        },
        [checkFormValidation, setErrorData, form]
      );
    
      console.log("admin form: ", form)
      const onBlurHandler = useCallback(
        (type) => {
          if (form?.[type]) {
            changeTextData(form?.[type].trim(), type);
          }
        },
        [changeTextData]
      );

      const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
      };

      const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
      };

  return {
    changeTextData,
    onBlurHandler,
    form,
    errorData,
    showPassword,
    togglePasswordVisibility,
    showConfirmPassword,
    toggleConfirmPasswordVisibility,
    listData,
    handleSubmit,
    AdminDetails,
    id
  }
}

export default useAdminUsersCreateHook